import { Box, Typography} from "@mui/material";
import { useTranslation } from "react-i18next";

function LoadingBox(props: {uaParser:UAParser.IResult,isGpsOn:boolean}): JSX.Element {

    const {
        uaParser,
        isGpsOn
    } = props
    
    const { t } = useTranslation();

    return (
        <Box
        height="100vh"
        width="100vw"
        flex="1"
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        position={"relative"}
      >
        {isGpsOn?
        <>
            <Box
                marginTop={3}
                marginBottom={3}
            >
                <img src="poolmelogo.png" width={"150px"}/>
            </Box>
            <Typography component="div" variant="caption" sx={{marginLeft:5,marginRight:5,marginTop:2}}>{t("component.loadingBox.slogan")}</Typography>
            <></>
        </>
        :
        <Box
        >
          <Box>
            {(uaParser?.device.type === "mobile" || uaParser?.device.type === "tablet")?
            (uaParser?.device.vendor === "Apple")?
            <>
            <Typography component="div" variant="caption" sx={{marginLeft:5,marginRight:5,marginTop:2}}>{t("component.loadingBox.locationPermission")}</Typography>
            <Typography component="div" variant="caption" sx={{marginLeft:5,marginRight:5,marginTop:2}}>{t("component.loadingBox.apple.step1")}</Typography>
            <Typography component="div" variant="caption" sx={{marginLeft:5,marginRight:5,marginTop:2}}>{t("component.loadingBox.apple.step2", { browser: uaParser?.browser.name })}</Typography>
            <Typography component="div" variant="caption" sx={{marginLeft:5,marginRight:5,marginTop:2}}>{t("component.loadingBox.apple.step3", { browser: uaParser?.browser.name })}</Typography>
            </>
            :
            <>
            <Typography component="div" variant="caption" sx={{marginLeft:5,marginRight:5,marginTop:2}}>{t("component.loadingBox.locationPermission")}</Typography>
            <Typography component="div" variant="caption" sx={{marginLeft:5,marginRight:5,marginTop:2}}>{t("component.loadingBox.android.step1", { browser: uaParser?.browser.name })}</Typography>
            </>
            :
            (uaParser?.browser.name == "Chrome")?
            <>
            <Typography component="div" variant="caption" sx={{marginLeft:5,marginRight:5,marginTop:2}}>{t("component.loadingBox.chrome.instruction")}</Typography>
            </>
            :
            <></>
            }
          </Box>
          <Box
            position={"absolute"}
            top={0}
          >
            <Typography component="div" variant="caption" sx={{marginLeft:5,marginRight:5,marginTop:2}}>{t("component.loadingBox.locationPermission")}</Typography>
          </Box>

        </Box>
        }
      </Box>
      );
};
export default LoadingBox;
